(function () {
  var grids = document.querySelectorAll('[data-op-grid]');
  if (!grids.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    grids.forEach(function (grid) {
      grid.classList.add('is-in-view');
      grid.querySelectorAll('[data-op-card]').forEach(function (card) {
        card.classList.add('is-visible');
      });
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var grid = entry.target;
        grid.classList.add('is-in-view');
        grid.querySelectorAll('[data-op-card]').forEach(function (card) {
          card.classList.add('is-visible');
        });
        observer.unobserve(grid);
      });
    },
    { threshold: 0.2 }
  );

  grids.forEach(function (grid) {
    observer.observe(grid);
  });
})();